import { useCallback } from 'react';

import { OrganisationAuthSettings } from './types';

type UseGetOrganisationAuthSettings = {
  apiUrl: string;
};

type GetOrganisationSettings = (organisation: string) => Promise<OrganisationAuthSettings>;

const useGetOrganisationAuthSettings = ({ apiUrl }: UseGetOrganisationAuthSettings): GetOrganisationSettings => {
  return useCallback(
    async (organisation: string) => {
      const response = await fetch(`${apiUrl}/auth/organisation/${organisation}`, {
        method: 'GET',
      });
      if (!response.ok) {
        throw new Error('Failed to get organisation settings');
      }
      const settings = (await response.json()) as OrganisationAuthSettings;
      return settings;
    },
    [apiUrl]
  );
};

export type { GetOrganisationSettings };

export { useGetOrganisationAuthSettings };
